import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../redux/store";
import { API_CONFIG } from "../../config"

export interface LoginApiResponse<T = unknown> {
    success: boolean;
    message: string;
    data: T;
    error?: string;
    status: number;
}

export const baseApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: API_CONFIG.BASE_URL,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as RootState).authSlice.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ["Centers", "Students", "Sessions", "Courses", "Users", "Attendance", "FeeTypes", "FeeConfig", "RegistrationFee", "BatchTiming", "Marks", "Settings", "Notifications", "Invoices", "CourseFeeShare", "RegistrationFeeShare", "BookRequests", "Shares", "OfflinePayments", "StarterKitInventory", "StarterKitTransaction", "StudentTransfers"],

    endpoints: () => ({}),
});